export default {
  delete_success: 'De aanbieding is succesvol verwijderd',
  delete_failed: 'Het verwijderen van de aanbieding is mislukt',
  delete_confirm_title: 'Weet u zeker dat u deze aanbieding wilt verwijderen?',
  delete_last_day_confirm_title:
    'Als je de laatste resterende dag verwijdert, wordt deze aanbieding verwijderd. Weet je het zeker?',
  confirm: 'Bevestigen',
  cancel: 'Annuleren',
  qualifying_items: 'Kwalificerende items',
  free_items: 'Gratis items',
  all_day: 'De hele dag',
  starts_on: 'Begint op {{date}}',
  ends_on: 'Eindigt op {{date}}',
  ends_when_deleted: 'Eindigt bij verwijdering',
  off: '{{amount}} korting',
  min_spend_value: 'Min. besteding: {{amount}}',
};
